// extracted by mini-css-extract-plugin
export default {"addCreditInput":"addCredit_addCreditInput__My5zN","buttonContainer":"addCredit_buttonContainer__JJbT7","sendCredits":"addCredit_sendCredits__MeLxS"};